import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ApiButton, Box, ContentTemplate } from 'web-library';
import Instruction from '../@candidate/Instruction';
import { usePostCreateResitRegistration } from '../../../../api-refactored/group-resit-registration/usePostCreateResitRegistration';
import { useResitNavigation } from '../../../../routes/ResitRoute';

const useStyles = makeStyles()((theme) =>
({
  instructionContainer: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    backgroundColor: theme.color.background.bgAlt,
  },
}));

interface InstructionConsentProps {
  show: boolean;
  setResitUuid: (resitUuid: string) => void;
}

const InstructionConsent = ({ show, setResitUuid }: InstructionConsentProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { accessToken } = useResitNavigation();

  const {
    mutate: postCreateResitRegistration,
    status: createResitRegistrationStatus,
  } = usePostCreateResitRegistration({
    token: accessToken,
    onSuccess: (resitResponse) => setResitUuid(resitResponse.uuid),
  });

  if (!show) {
    return null;
  }

  return (
    <ContentTemplate>
      <Instruction />

      <Box className={classes.instructionContainer}>
        <ApiButton
          id="button-instructionConsent-start"
          status={createResitRegistrationStatus}
          onClick={() => postCreateResitRegistration()}
        >
          {t('resit->>ResitInstruction.Start')}
        </ApiButton>
      </Box>
    </ContentTemplate>
  );
};

export default InstructionConsent;
